// Runder Glas-Knopf der Filterzeile (Handoff Rechnungen §4: Objekt, Haus, Gruppieren, Filter): 44 px, Radius 22,
// aktiv = Akzentfläche (--acc-soft / --acc). Optional mit Pfeil für Aufklappfenster.
import { forwardRef, type ReactNode } from 'react';
import { CaretDown, type Icon } from '@phosphor-icons/react';

export interface PillenKnopfProps {
  icon: Icon;
  children: ReactNode;
  aktiv?: boolean;
  offen?: boolean;
  /** zeigt den Pfeil nach unten (Aufklappfenster) */
  aufklapp?: boolean;
  onClick: () => void;
  tip?: string;
  maxBreite?: number;
  hoehe?: number;
}

export const PillenKnopf = forwardRef<HTMLButtonElement, PillenKnopfProps>(function PillenKnopf(
  { icon: I, children, aktiv = false, offen, aufklapp = false, onClick, tip, maxBreite, hoehe = 44 }, ref,
) {
  return (
    <button ref={ref} type="button" onClick={onClick} data-tip={tip} aria-expanded={aufklapp ? !!offen : undefined} aria-pressed={aufklapp ? undefined : aktiv}
      className="inline-flex min-w-0 items-center"
      style={{ height: hoehe, padding: '0 14px', gap: 7, maxWidth: maxBreite, borderRadius: hoehe / 2, border: 'none', cursor: 'pointer', fontFamily: 'inherit',
        fontSize: 13, fontWeight: 700, background: aktiv ? 'var(--acc-soft)' : 'var(--glass)', color: aktiv ? 'var(--acc)' : 'var(--ink)', boxShadow: 'var(--glass-sh)',
        WebkitBackdropFilter: 'blur(28px)', backdropFilter: 'blur(28px)' }}>
      <I size={15} weight="bold" className="shrink-0" />
      <span className="truncate">{children}</span>
      {aufklapp && <CaretDown size={12} weight="bold" className="shrink-0" style={{ transition: 'transform .2s', transform: offen ? 'rotate(180deg)' : 'none' }} />}
    </button>
  );
});
